import React, { useState } from "react";
import classes from "./Confirmation.module.css";
import { motion } from "framer-motion";
import { useNavigate, useLocation } from "react-router-dom";
import { FaQuestion } from "react-icons/fa6";
import { toast } from "react-toastify";
import { activateUserApi } from "../http/http";
import { useTranslation } from "react-i18next";

const ConfirmationPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();

  const mobile = location.state?.mobile;
  const selectedPlan = location.state?.selectedPlan ?? 2;
  const pack = location.state?.pack;
  const otp = location.state?.otp;
  const extRef = location.state?.ext_ref;

  const [loading, setLoading] = useState(false);

  const handleConfirm = async () => {
    if (loading) return;

    if (!mobile) {
      toast.error(t("145"));
      navigate("/subscribe");
      return;
    }

    console.log(mobile,"====mobile===");

    const packType =
      pack === "daily" || selectedPlan === 1 ? "Daily" : "Weekly";

    // Prefer a backend-provided external reference.
    // The OTP is used as a fallback only if your backend
    // specifically expects it as ext_ref.
    const externalReference = extRef ?? otp;

    if (!externalReference) {
      toast.error(t("146"));
      return;
    }

    try {
      setLoading(true);

      const response = await activateUserApi(
        mobile.replace(/\s/g, ""),
        externalReference,
        packType
      );

 const result = response?.data;

if (result?.status === 4 || result?.status === 3) {
  // Normalize the number and save it before navigating.
  const digits = mobile.replace(/\D/g, "");

  const msisdn = digits.startsWith("241")
    ? digits
    : `241${digits.startsWith("0") ? digits.slice(1) : digits}`;

  localStorage.setItem("msisdn", msisdn);

  console.log("Subscription successful:", result);
  console.log("Saved MSISDN:", localStorage.getItem("msisdn"));

  toast.success(result.message || t("147"));

  navigate("/home", { replace: true });
  return;

      } else if (result?.message === "Subscription already exist.") {
        toast.info(result.message);
      } else if (result?.status === 0) {
        toast.error(result.message || "MSISDN is Blacklisted.");
      } else {
        toast.error(result?.message || t("148"));
      }
    } catch (error) {
      const result = error?.response?.data;

      if (result?.message === "MSISDN is Blacklisted.") {
        toast.error(result.message);
      } else if (result?.message === "Subscription already exist.") {
        toast.info(result.message);
      } else if (result?.message === "Internal Server Error") {
        toast.error(t("138"));
      } else {
        toast.error(
          result?.message || t("148")
        );
      }
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    navigate("/subscribe");
  };

  return (
    <main className={classes.main}>
      <div className={classes.glowLayer} />

      <motion.section
        className={classes.container}
        initial={{ opacity: 0, y: 20, scale: 0.96 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        transition={{ duration: 0.45, ease: "easeOut" }}
      >
        <div className={classes.bgGlowOne} />
        <div className={classes.bgGlowTwo} />

        <motion.div
          className={classes.iconWrap}
          initial={{ scale: 0.7, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ delay: 0.15, duration: 0.35 }}
        >
          <FaQuestion />
        </motion.div>

        <h1 className={classes.title}>{t("140")}</h1>

        <p className={classes.subtitle}>
          {t("141")}
        </p>

        <div className={classes.buttonGroup}>
          <motion.button
            type="button"
            className={classes.noBtn}
            onClick={handleCancel}
            disabled={loading}
            whileHover={!loading ? { scale: 1.03 } : {}}
            whileTap={!loading ? { scale: 0.97 } : {}}
          >
            {t("142")}
          </motion.button>

          <motion.button
            type="button"
            className={classes.yesBtn}
            onClick={handleConfirm}
            disabled={loading}
            whileHover={!loading ? { scale: 1.03 } : {}}
            whileTap={!loading ? { scale: 0.97 } : {}}
          >
            {loading ? t("144") : t("143")}
          </motion.button>
        </div>
      </motion.section>
    </main>
  );
};

export default ConfirmationPage;
